/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * WHIS API documentation
 * This document list all APIs available for WHIS project
 * OpenAPI spec version: 1.1.15
 */

/**
 * Human affected
 */
export type ImportReportDtoHumanAffected =
  (typeof ImportReportDtoHumanAffected)[keyof typeof ImportReportDtoHumanAffected];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ImportReportDtoHumanAffected = {
  yes: 'yes',
  no: 'no',
  dontKnow: 'dontKnow',
} as const;
